/* eslint-disable import/no-named-default */
import React from 'react';
import PropTypes from 'prop-types';
import { default as MUISlider } from '@mui/material/Slider';
import { useFormContext, Controller } from 'react-hook-form';
import { cn } from '@src/utils/ui';

export const Slider = ({ name, ...rest }) => {
    const { control } = useFormContext();

    return (
        <Controller
            name={name}
            control={control}
            render={({ field }) => (
                <MUISlider
                    {...field}
                    {...rest}
                    value={field.value}
                    className={cn('tw-grow', rest.className)}
                    valueLabelDisplay='auto'
                    sx={{
                        color: '#0050C4',
                        '& .MuiSlider-thumb': {
                            borderColor: '#0050C4'
                        },
                        '& .MuiSlider-rail': {
                            color: '#6693DB'
                        }
                    }}
                />
            )}
        />
    );
};

// -------- PropTypes -------- //

Slider.propTypes = {
    name: PropTypes.string.isRequired
};
